import React, { useEffect, useState } from "react";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { RiPriceTag3Line } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import OpenOrgSettings from "./OpenOrgPages/OpenOrgSettings";
import OpenOrgMembers from "./OpenOrgPages/OpenOrgMembers";
import OpenOrgDelete from "./OpenOrgPages/OpenOrgDelete";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenOrganization = ({
    account_id,
    userData,
    singleOrgData,
    loadingSingleOrg,
    fetchSingleOrganization
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id, org_page } = useParams()
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)

    const handleNavPage = (page) => {
        navigate(`/console/organizations/${org_id}/manage-org/${page}`)
    }


    return (
        <div className="analytics_cont">
            <div className="analytics_cont_header">
                <div className="analytics_cont_header_title">
                    <p className="mainframe_item_title fade-in">{t.organizations.manage_organization}</p>
                    <div className="analytics_cont_header_title_btn_cont">
                        {/* <button className="analytics_cont_header_title_btn fade-in"><HiOutlineDocumentSearch /> {t.documentation}</button> */}
                    </div>
                </div>
                <div className="navigation_btns_analytics">
                    <button className={`navigation_btns_analytics_btn fade-in ${org_page == "settings" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("settings")}>{t.organizations.settings}</button>
                    <button className={`navigation_btns_analytics_btn fade-in ${org_page == "members" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("members")}>{t.organizations.members}</button>
                    <button className={`navigation_btns_analytics_btn fade-in ${org_page == "close-org" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("close-org")}>{t.organizations.close_org}</button>
                </div>
            </div>
            <div className="analytics_cont_body">
                {org_page == "settings" && (
                    <OpenOrgSettings
                        account_id={account_id}
                        org_id={org_id}
                        singleOrgData={singleOrgData}
                        loadingSingleOrg={loadingSingleOrg}
                        fetchSingleOrganization={fetchSingleOrganization}
                    />
                )}

                {org_page == "members" && (
                    <OpenOrgMembers
                        account_id={account_id}
                        userData={userData}
                        org_id={org_id}
                    />
                )}

                {org_page == "close-org" && (
                    <OpenOrgDelete
                        account_id={account_id}
                        userData={userData}
                        org_id={org_id}
                    />
                )}
            </div>
        </div>
    )
}

export default OpenOrganization